export const parsePrice = value => {
  return `${String(value).replace('.', ',')} €`
}
